import { Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[custom-container-host]'
})
export class CustomContainerDirective {
  @Input() currentComponent:any;
  constructor(public viewContainerRef: ViewContainerRef) { }

}
